export class DataTableUtil {
  static SetColumn(column: Array<string>): [] {
    let columns: any = [];
    column.forEach(function (element: string) {
      if (element === "key") {
        columns.push({
          title: "S/N",
          dataIndex: element,
          width: "6%",
        });
      } 
      else if (element === "Performed By") {
        columns.push({
          title: "Performed By",
          dataIndex: "performedBy",
          width: "20%",
        });
      }
      else if (element === "createdBy") {
        columns.push({
          title: "Date",
          dataIndex: "date",
          width: "15%",
        });
      }
      else if(element === "Action"){
        columns.push({
          title: "Status",
          dataIndex: '',
          width: "10%",
          fixed: "right"
        });
      }
      
      else {
        const columnName = element?.split("_")[0];
        const columnWidth =
          element.split("_").length > 1 ? element.split("_")[1] : null;
        let value = columnName.replace(/ /g, "");
        value = value.charAt(0).toLowerCase() + value.slice(1);

        columns.push({
          title: columnName,
          dataIndex: value,
          width: columnWidth,
        });
      }
    });
    return columns;
  }

  static SetExcelColumn(column: Array<string>) {
    let columns: any = [];
    column.forEach(function (element: string) {
      columns.push({
        title: element,
        width: { wpx: 160 },
      });
    });
    return columns;
  }
}
